
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2928',
  depVersions: {
  "customer-portal-app": "static-1.2928",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9861",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25966",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5797",
  "hs-test-utils": "static-1.8227",
  "hub-http": "static-1.6421",
  "hub-http-shared-msw-handlers": "static-1.10449",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18806",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11678",
  "I18n": "static-7.1650",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6658",
  "payment-link-components": "static-1.23980",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7301",
  "quartz-core": "static-1.6520",
  "quartz-i18n": "static-1.976",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10413",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5482",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20175",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18263",
  "ui-components-test-utils": "static-1.5815",
  "UIComponents": "static-3.8624",
  "foundations-assets": "static-1.5079",
  "foundations-components": "static-1.8312",
  "foundations-theming": "static-1.4645",
  "foundations-theming-specialty": "static-1.2361",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1276",
  "quartz-config": "static-1.1079",
  "quartz-routing": "static-1.731",
  "quick-fetch": "static-1.4059",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-aeastham-base-reporter-resolved-tracking.4",
  "rpc-client-utils": "static-1.4862",
  "sanitize-text": "static-1.8350",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4958",
  "ui-addon-react-router-dom": "static-1.9737",
  "usage-tracker": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-anonymous": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.6",
  "video-components-external": "static-1.11926",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3541",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3578",
  "quartz-webpack": "static-1.3525",
  "bend-plugin-quartz-routing": "static-1.379",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7884",
  "frontend-preferences-client": "static-1.8130",
  "laboratory-lib": "static-3.7355",
  "onboarding-scopes": "static-1.6662",
  "seat-types-lib": "static-1.467",
  "ui-addon-opt": "static-4.8564",
  "HeadJS": "static-2.781",
  "hs-test-utils-bend-plugin": "static-1.3338",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.222",
  "ts-schema": "static-1.4221",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8063",
  "content-media-capture": "static-1.5161",
  "cssUtils": "static-1.851",
  "customer-data-ui-utilities": "static-1.10029",
  "file-manager-components": "static-1.24219",
  "HubStyle": "static-2.11985",
  "knowledge-content-types": "static-1.8595",
  "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.491",
  "ui-addon-emoji-picker": "static-1.10089",
  "ui-addon-i18n": "static-1.11350",
  "ui-business-units-lib": "static-1.9284",
  "ui-shepherd-react": "static-3.10465",
  "video-data-lib": "static-1.35584",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4527",
  "commerce-tours-lib": "static-1.6470",
  "customer-data-properties": "static-1.52278",
  "getting-started-shared-tasks": "static-1.19001",
  "growth-onboarding-reliability": "static-1.5286",
  "onboarding-tours": "static-1.16975",
  "reference-resolvers-lite": "static-1.8301",
  "sales-checkout-service-client": "static-1.3743",
  "ui-addon-iframeable": "static-1.9279",
  "user-context": "static-1.5315",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.858",
  "hubspotter-http": "static-1.4792",
  "icons": "static-2.668",
  "mobile-manifest-mixins": "static-1.555",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.976",
  "quartz-head": "static-1.966",
  "quartz-test": "static-1.976",
  "quartz-tracking": "static-1.680",
  "trellis-components": "static-1.2360",
  "ui-fonts": "static-1.940",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.6",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9630",
  "data-token-picker": "static-1.16756",
  "FileManagerLib": "static-1.39859",
  "property-translator": "static-1.5599",
  "atom": "static-1.5280",
  "merchandise-lib": "static-1.269",
  "purchase-motions-components": "static-1.6216",
  "salesImages": "static-1.529",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5795",
  "react-create-root-preference": "static-1.50",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1212",
  "bend-plugin-foundations-components": "static-1.4581",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2341",
  "bend-plugin-foundations-theming": "static-1.3128",
  "foundations-theming-base": "static-1.3630",
  "stylex": "static-1.37",
  "interframe": "static-3.4959",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1-session-replay-endpoint-migration.6",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.272",
  "chirp-fetch": "static-1.2091",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4681",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4857",
  "content-media-composition-data-lib": "static-1.12965",
  "content-media-compositions": "static-2.16972",
  "idb-keyval": "static-1.47",
  "immer": "static-1.33",
  "immerable": "static-1.4351",
  "magpie-lib": "static-1.5696",
  "magpie-types": "static-1.5156",
  "media-bridge-lib": "static-1.19274",
  "bender-build-tools": "static-1.3322",
  "usage-tracker-public": "static-1-session-replay-endpoint-migration.6",
  "inbound-db-properties-service-client": "static-1.3986",
  "superstore": "static-1.4962",
  "feedback-loader": "static-1.29665",
  "ai-components-ui-library": "static-1.9466",
  "ui-addon-video-player": "static-1.8910",
  "ui-coaching-tips": "static-1.29119",
  "ContentUtils": "static-1.68950",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4629",
  "sassPrefix": "static-1.160",
  "react-dnd-compat": "static-1.4818",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1430",
  "copilot-toolkit": "static-1.11652",
  "avatar-components": "static-1.2701",
  "navigation-messaging": "static-1.7927",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8380",
  "commerce-products-lib": "static-1.10284",
  "crm-message-bus": "static-1.43549",
  "growth-data-modal": "static-1.5754",
  "hubspot-apollo-client": "static-1.5081",
  "onboarding-tours-client": "static-1.5189",
  "batch-promise": "static-1.1748",
  "calling-global-api": "static-1.65192",
  "calling-internal-common": "static-1.31518",
  "calling-lifecycle-internal": "static-1.66574",
  "calling-lifecycle-messages": "static-1.58868",
  "conditional-properties-service-client": "static-1.3938",
  "crm-links": "static-1.6521",
  "crm-index-visualization-core": "static-1.4404",
  "crm-pipelines-api-client-types": "static-1.4279",
  "customer-data-objects-ui-components": "static-1.13236",
  "customer-data-properties-shared-msw-handlers": "static-1.9776",
  "customer-data-property-utils": "static-1.8300",
  "external-options-client-types": "static-1.4267",
  "formula-editor": "static-1.14608",
  "framework-data-schema-resolvers": "static-1.7098",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.383",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4357",
  "meetings-icalendar-utils-lib": "static-1.835",
  "multi-currency-client-types": "static-1.3832",
  "object-builder-ui-client": "static-1.49402",
  "pipeline-validation-client-types": "static-1.4107",
  "property-value-citations": "static-1.2892",
  "pulse": "static-1.820",
  "smart-property-lib": "static-1.8096",
  "tiered-pricing": "static-1.1776",
  "topics-actions-lib": "static-1.359",
  "ui-addon-form-validation": "static-1.11193",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3265",
  "growth-onboarding-next-action-utils": "static-1.2499",
  "navigation-components": "static-1.18600",
  "onboarding-tours-utils": "static-1.1041",
  "ui-shepherd-tracker": "static-1.7846",
  "ui-universal-auth": "static-1.9222",
  "getting-started-shared-tasks-store": "static-1.18119",
  "hubspotter-http-shared-msw-handlers": "static-1.10447",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.6",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1155",
  "tanstack-virtual": "static-1.33",
  "audio-components": "static-1.6213",
  "FileManagerCore": "static-1.39718",
  "FileManagerImages": "static-1.37370",
  "video-components": "static-1.13928",
  "foundations-components-legacy": "static-1.1337",
  "purchase-motions-api": "static-1.6219",
  "signup-constants": "static-1.19378",
  "signup-ui-url-generator": "static-2.8261",
  "reactive-lib": "static-1.926",
  "simple-logging-lib": "static-1.3253",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22343",
  "growth-onboarding-feedback-components": "static-1.6785",
  "cms-field-types": "static-1.5019",
  "content-icons-ui": "static-1.2287",
  "integrations-lib": "static-1.16791",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.708",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.980",
  "customer-data-tracking": "static-1.7088",
  "products-iframe-lib": "static-1.8408",
  "products-ui-components-shared-msw-handlers": "static-1.10831",
  "restore-request-side-panel-lib": "static-1.1412",
  "onboarding-data-sync-lib": "static-1.2315",
  "hubspot-apollo-cache": "static-1.540",
  "calling-error-reporting": "static-1.31525",
  "shared-worker-versioning": "static-1.11241",
  "calling-usage-tracker": "static-1.6744",
  "voice-sms-access-library": "static-1.1725",
  "conversations-skeleton-state": "static-1.7451",
  "location-customization-utils-lib": "static-1.9875",
  "crm-index-associations-lib": "static-1.6645",
  "framework-data-schema-quick-fetch": "static-1.7003",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10532",
  "redux-toolkit": "static-1.7",
  "sales-views-client-types": "static-1.4461",
  "bark-lib": "static-1.16700",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6091",
  "react-codemirror": "static-1.10844",
  "fdsr-migration-layer": "static-1.217",
  "framework-builder-read-service-client": "static-1.4147",
  "persist-promise": "static-1.3905",
  "event-emitter": "static-1.1154",
  "bend-plugin-pulse": "static-1.323",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.509",
  "fsm": "static-1.3936",
  "policy-lib": "static-1.6991",
  "react-tinymce": "static-1.55778",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10595",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54904",
  "tinymce-plugins": "static-1.58018",
  "tinymce-themes": "static-1.56874",
  "growth-onboarding-next-action-components": "static-1.2527",
  "user-context-client": "static-1.4754",
  "nest": "static-1.440",
  "unified-auth-core-lib": "static-1.1018",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4736",
  "video-embed": "static-1.36418",
  "social-insights-client-types": "static-1.22596",
  "flux-actions": "static-1.355",
  "integrations-error-boundary-lib": "static-1.14206",
  "integrations-tracking-lib": "static-1.5811",
  "native-integrations-shared-strings": "static-1.7982",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10569",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.736",
  "InboxConnectUtils": "static-4.15358",
  "meetings-connect-utils-lib": "static-1.7809",
  "calling-orchestration-schema": "static-1.36502",
  "crm-record-cards-service-types": "static-1.3725",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16155",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4711",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3245",
  "tinymce-data": "static-1.40989",
  "ui-addon-sales-email": "static-1.5416",
  "layout-dnd-components": "static-1.12826",
  "layout-dnd-utils": "static-1.11801",
  "ui-brand-identity-lib": "static-1.16024",
  "NamespacedHubStyle": "static-2.9191",
  "outpost": "static-1.4370",
  "universal-page-editor-lib": "static-1.3215",
  "adobe-sign-auth-lib": "static-1.253",
  "ads-unified-auth-lib": "static-1.774",
  "google-sheets-integration-lib": "static-1.830",
  "microsoft-drive-integration-lib": "static-1.940",
  "surveymonkey-integration-lib": "static-1.276",
  "slack-ui-library": "static-1.10603",
  "ContentData": "static-1.69025",
  "layout-data-lib": "static-1.10126",
  "advanced-menus-core": "static-1.15452",
  "advanced-menus-lib": "static-1.12344",
  "ExportDialog": "static-6.10583",
  "ui-memberships-settings-lib": "static-1.34609",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15451",
  "simple-menus-lib": "static-1.16968"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2928",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9861",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25966",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5797",
  "hs-test-utils": "/hs-test-utils/static-1.8227",
  "hub-http": "/hub-http/static-1.6421",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10449",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11678",
  "I18n": "/I18n/static-7.1650",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6658",
  "payment-link-components": "/payment-link-components/static-1.23980",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7301",
  "quartz-core": "/quartz-core/static-1.6520",
  "quartz-i18n": "/quartz-i18n/static-1.976",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10413",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5482",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20175",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18263",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5815",
  "UIComponents": "/UIComponents/static-3.8624",
  "foundations-assets": "/foundations-assets/static-1.5079",
  "foundations-components": "/foundations-components/static-1.8312",
  "foundations-theming": "/foundations-theming/static-1.4645",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2361",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1276",
  "quartz-config": "/quartz-config/static-1.1079",
  "quartz-routing": "/quartz-routing/static-1.731",
  "quick-fetch": "/quick-fetch/static-1.4059",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-aeastham-base-reporter-resolved-tracking.4",
  "rpc-client-utils": "/rpc-client-utils/static-1.4862",
  "sanitize-text": "/sanitize-text/static-1.8350",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4958",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9737",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.6",
  "video-components-external": "/video-components-external/static-1.11926",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3541",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3578",
  "quartz-webpack": "/quartz-webpack/static-1.3525",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.379",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7884",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8130",
  "laboratory-lib": "/laboratory-lib/static-3.7355",
  "onboarding-scopes": "/onboarding-scopes/static-1.6662",
  "seat-types-lib": "/seat-types-lib/static-1.467",
  "ui-addon-opt": "/ui-addon-opt/static-4.8564",
  "HeadJS": "/HeadJS/static-2.781",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3338",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.222",
  "ts-schema": "/ts-schema/static-1.4221",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8063",
  "content-media-capture": "/content-media-capture/static-1.5161",
  "cssUtils": "/cssUtils/static-1.851",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10029",
  "file-manager-components": "/file-manager-components/static-1.24219",
  "HubStyle": "/HubStyle/static-2.11985",
  "knowledge-content-types": "/knowledge-content-types/static-1.8595",
  "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10089",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11350",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9284",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10465",
  "video-data-lib": "/video-data-lib/static-1.35584",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4527",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6470",
  "customer-data-properties": "/customer-data-properties/static-1.52278",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19001",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5286",
  "onboarding-tours": "/onboarding-tours/static-1.16975",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8301",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9279",
  "user-context": "/user-context/static-1.5315",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.858",
  "hubspotter-http": "/hubspotter-http/static-1.4792",
  "icons": "/icons/static-2.668",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.976",
  "quartz-head": "/quartz-head/static-1.966",
  "quartz-test": "/quartz-test/static-1.976",
  "quartz-tracking": "/quartz-tracking/static-1.680",
  "trellis-components": "/trellis-components/static-1.2360",
  "ui-fonts": "/ui-fonts/static-1.940",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.6",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9630",
  "data-token-picker": "/data-token-picker/static-1.16756",
  "FileManagerLib": "/FileManagerLib/static-1.39859",
  "property-translator": "/property-translator/static-1.5599",
  "atom": "/atom/static-1.5280",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "purchase-motions-components": "/purchase-motions-components/static-1.6216",
  "salesImages": "/salesImages/static-1.529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5795",
  "react-create-root-preference": "/react-create-root-preference/static-1.50",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1212",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4581",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2341",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3128",
  "foundations-theming-base": "/foundations-theming-base/static-1.3630",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4959",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-session-replay-endpoint-migration.6",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.272",
  "chirp-fetch": "/chirp-fetch/static-1.2091",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4681",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4857",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12965",
  "content-media-compositions": "/content-media-compositions/static-2.16972",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4351",
  "magpie-lib": "/magpie-lib/static-1.5696",
  "magpie-types": "/magpie-types/static-1.5156",
  "media-bridge-lib": "/media-bridge-lib/static-1.19274",
  "bender-build-tools": "/bender-build-tools/static-1.3322",
  "usage-tracker-public": "/usage-tracker-public/static-1-session-replay-endpoint-migration.6",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3986",
  "superstore": "/superstore/static-1.4962",
  "feedback-loader": "/feedback-loader/static-1.29665",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9466",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8910",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29119",
  "ContentUtils": "/ContentUtils/static-1.68950",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4629",
  "sassPrefix": "/sassPrefix/static-1.160",
  "react-dnd-compat": "/react-dnd-compat/static-1.4818",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1430",
  "copilot-toolkit": "/copilot-toolkit/static-1.11652",
  "avatar-components": "/avatar-components/static-1.2701",
  "navigation-messaging": "/navigation-messaging/static-1.7927",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8380",
  "commerce-products-lib": "/commerce-products-lib/static-1.10284",
  "crm-message-bus": "/crm-message-bus/static-1.43549",
  "growth-data-modal": "/growth-data-modal/static-1.5754",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5081",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5189",
  "batch-promise": "/batch-promise/static-1.1748",
  "calling-global-api": "/calling-global-api/static-1.65192",
  "calling-internal-common": "/calling-internal-common/static-1.31518",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66574",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58868",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3938",
  "crm-links": "/crm-links/static-1.6521",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4404",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4279",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13236",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9776",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8300",
  "external-options-client-types": "/external-options-client-types/static-1.4267",
  "formula-editor": "/formula-editor/static-1.14608",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7098",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.383",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4357",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.835",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3832",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49402",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4107",
  "property-value-citations": "/property-value-citations/static-1.2892",
  "pulse": "/pulse/static-1.820",
  "smart-property-lib": "/smart-property-lib/static-1.8096",
  "tiered-pricing": "/tiered-pricing/static-1.1776",
  "topics-actions-lib": "/topics-actions-lib/static-1.359",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11193",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3265",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2499",
  "navigation-components": "/navigation-components/static-1.18600",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1041",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7846",
  "ui-universal-auth": "/ui-universal-auth/static-1.9222",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18119",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10447",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.6",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1155",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "audio-components": "/audio-components/static-1.6213",
  "FileManagerCore": "/FileManagerCore/static-1.39718",
  "FileManagerImages": "/FileManagerImages/static-1.37370",
  "video-components": "/video-components/static-1.13928",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1337",
  "purchase-motions-api": "/purchase-motions-api/static-1.6219",
  "signup-constants": "/signup-constants/static-1.19378",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8261",
  "reactive-lib": "/reactive-lib/static-1.926",
  "simple-logging-lib": "/simple-logging-lib/static-1.3253",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22343",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6785",
  "cms-field-types": "/cms-field-types/static-1.5019",
  "content-icons-ui": "/content-icons-ui/static-1.2287",
  "integrations-lib": "/integrations-lib/static-1.16791",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.708",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.980",
  "customer-data-tracking": "/customer-data-tracking/static-1.7088",
  "products-iframe-lib": "/products-iframe-lib/static-1.8408",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10831",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1412",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2315",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.540",
  "calling-error-reporting": "/calling-error-reporting/static-1.31525",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11241",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6744",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1725",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7451",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9875",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6645",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7003",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10532",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "sales-views-client-types": "/sales-views-client-types/static-1.4461",
  "bark-lib": "/bark-lib/static-1.16700",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6091",
  "react-codemirror": "/react-codemirror/static-1.10844",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.217",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4147",
  "persist-promise": "/persist-promise/static-1.3905",
  "event-emitter": "/event-emitter/static-1.1154",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.323",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.509",
  "fsm": "/fsm/static-1.3936",
  "policy-lib": "/policy-lib/static-1.6991",
  "react-tinymce": "/react-tinymce/static-1.55778",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10595",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54904",
  "tinymce-plugins": "/tinymce-plugins/static-1.58018",
  "tinymce-themes": "/tinymce-themes/static-1.56874",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2527",
  "user-context-client": "/user-context-client/static-1.4754",
  "nest": "/nest/static-1.440",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1018",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4736",
  "video-embed": "/video-embed/static-1.36418",
  "social-insights-client-types": "/social-insights-client-types/static-1.22596",
  "flux-actions": "/flux-actions/static-1.355",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14206",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5811",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7982",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10569",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.736",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15358",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7809",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36502",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3725",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16155",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4711",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3245",
  "tinymce-data": "/tinymce-data/static-1.40989",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5416",
  "layout-dnd-components": "/layout-dnd-components/static-1.12826",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11801",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16024",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9191",
  "outpost": "/outpost/static-1.4370",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3215",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.253",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.774",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.830",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.940",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.276",
  "slack-ui-library": "/slack-ui-library/static-1.10603",
  "ContentData": "/ContentData/static-1.69025",
  "layout-data-lib": "/layout-data-lib/static-1.10126",
  "advanced-menus-core": "/advanced-menus-core/static-1.15452",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12344",
  "ExportDialog": "/ExportDialog/static-6.10583",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34609",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15451",
  "simple-menus-lib": "/simple-menus-lib/static-1.16968"
}
};
